import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PublicRoute from 'enums/publicRoutes';
import { useAuth } from 'hooks/useAuth';
import { useIntl } from 'react-intl';
import { useBreakpoint } from 'utils/useBreakpoint';
import { Button } from 'ui';
import { StyledMobileAuthEntry } from './style';

export const MobileAuthEntry = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { user, isFetchingUser } = useAuth();
  const { isLg } = useBreakpoint();

  useEffect(() => {
    if (isLg) {
      navigate(PublicRoute.LOGIN);
      return;
    }

    if (user?.authenticated && !isFetchingUser) {
      navigate(PublicRoute.HOME);
    }
  }, [isLg, user, isFetchingUser, navigate]);

  if (user?.authenticated) return null;

  return (
    <StyledMobileAuthEntry>
      <div className={'mobile-auth-entry-container'}>
        <div className={'mobile-auth-entry-overlay'} />
        <div className={'mobile-auth-entry-logo'}>
          <img src={'/NG-peleks-1.png'} alt={'Novada Garsa'} />
        </div>
        <div className={'mobile-auth-entry-actions'}>
          <Button
            className={'login'}
            size={'large'}
            label={intl.formatMessage({ id: 'register.login' })}
            onClick={() => navigate(PublicRoute.LOGIN)}
          />
          <Button
            size={'large'}
            label={intl.formatMessage({ id: 'login.register' })}
            onClick={() => navigate(PublicRoute.REGISTER)}
          />
        </div>
      </div>
    </StyledMobileAuthEntry>
  );
};
